const SEVERITY_ORDER = { critical: 0, high: 1, warning: 2, attention: 3, info: 4 };

// Alarm severity -> status-palette family (cssTokens.js --status-*), the
// vocabulary StatusChip/AlarmChip speak. `high` gets the same red/"bad"
// treatment as `critical` — same operational weight, one rank below it.
const SEVERITY_STATUS_FAMILY = {
  critical: 'bad',
  high: 'bad',
  warning: 'warning',
  attention: 'attention',
  info: 'info',
};

// Literal map-marker hexes mirroring the light-scheme status palette
// (cssTokens.js --status-bad/-warning/-attention/-info), inlined so this
// module stays dependency-free for plain-node unit tests.
const SEVERITY_HEX = {
  critical: '#DC2626',
  high: '#DC2626',
  warning: '#F59E0B',
  attention: '#7C3AED',
  info: '#0284C7',
};

export function compareSeverity(a, b) {
  // An unrecognized severity sorts last — one past the worst known rank
  // (`info`), never ahead of a real severity it isn't.
  const unknownRank = Object.keys(SEVERITY_ORDER).length;
  return (SEVERITY_ORDER[a] ?? unknownRank) - (SEVERITY_ORDER[b] ?? unknownRank);
}

export function getSeverityColor(severity) {
  return SEVERITY_HEX[severity] ?? SEVERITY_HEX.warning;
}

export function severityStatusFamily(severity) {
  return SEVERITY_STATUS_FAMILY[severity] ?? 'warning';
}

export function getHighestSeverity(alarmStates, accessor = a => a?.severity) {
  let best = null;
  for (const state of alarmStates) {
    const sev = accessor(state) || 'warning';
    if (best == null || compareSeverity(sev, best) < 0) best = sev;
  }
  return best;
}
